import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { get } from 'lodash-es';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { getImageUrl, SOURCES } from 'client/utils/image-helpers';
import { withCoreMediaWrapper } from 'site-modules/shared/components/core-page/core-media-wrapper/core-media-wrapper';
import { PhotoflipperButtonAsync } from 'site-modules/shared/components/photoflipper-core/photoflipper-button/photoflipper-button-async';
import { VehicleImage } from 'site-modules/shared/components/vehicle-image/vehicle-image';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

import './vehicle-photo.scss';

function VehiclePhotoUI({
  vehicle,
  coreMedia = null,
  wrapperClassNames = null,
  iconClassNames = null,
  dataTrackingId = null,
  altText = null,
  allocateSpace = false,
  isLazyLoad = false,
}) {
  if (!coreMedia) {
    return null;
  }

  const { heroImage } = coreMedia;

  const image = (
    <VehicleImage
      vehicle={vehicle}
      photoDescText={altText}
      src={getImageUrl(get(heroImage, 'src'), undefined, SOURCES.MEDIA)}
      isLifestylePhoto={get(heroImage, 'isLifestylePhoto')}
      isLazyLoad={isLazyLoad}
    />
  );
  const wrappedImage = allocateSpace ? <AspectRatioContainer aspectRatio="3:2">{image}</AspectRatioContainer> : image;

  return (
    <div className={classNames('pos-r vehicle-photo', wrapperClassNames)}>
      <PhotoflipperButtonAsync
        makeSlug={vehicle.make.slug}
        modelSlug={vehicle.model.slug}
        year={vehicle.year}
        submodel={get(vehicle, 'submodels.name')}
        dataTrackingId={dataTrackingId}
      >
        <button className="btn border-0 p-0 w-100">
          <span className="visually-hidden">View Photos</span>
          {wrappedImage}
          {iconClassNames && <i className={iconClassNames} />}
        </button>
      </PhotoflipperButtonAsync>
    </div>
  );
}

VehiclePhotoUI.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
  coreMedia: PropTypes.shape({
    heroImage: PropTypes.shape({
      src: PropTypes.string,
      isLifestylePhoto: PropTypes.bool,
    }),
  }),
  wrapperClassNames: PropTypes.string,
  iconClassNames: PropTypes.string,
  dataTrackingId: PropTypes.string,
  altText: PropTypes.string,
  allocateSpace: PropTypes.bool,
  isLazyLoad: PropTypes.bool,
};

export const VehiclePhoto = withCoreMediaWrapper(VehiclePhotoUI);
